module.exports = __webpack_public_path__ + "img/razorpay.e2565c86.svg";